import * as React from "react";

const Logout = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={800}
		height={800}
		fill="none"
		viewBox="0 0 24 24"
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="m19 12-4-4m4 4-4 4m4-4H9m5 9a9 9 0 1 1 0-18"
		/>
	</svg>
);

export default Logout;
